import React from 'react';
import '../styles/TemplateFilters.css';

function TemplateFilters({
  categories,
  selectedCategories,
  onCategoryChange,
  priceRange,
  onPriceRangeChange,
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
  totalCount,
}) {
  const sortOptions = [
    { value: 'price_desc', label: 'Price: High to Low' },
    { value: 'price_asc', label: 'Price: Low to High' },
    { value: 'name', label: 'Name A-Z' },
    { value: 'popular', label: 'Most Popular' },
  ];

  const handleCategoryToggle = (category) => {
    if (selectedCategories.includes(category)) {
      onCategoryChange(selectedCategories.filter((c) => c !== category));
    } else {
      onCategoryChange([...selectedCategories, category]);
    }
  };

  const formatPrice = (cents) => {
    const dollars = cents / 100;
    return dollars < 10 ? `$${dollars.toFixed(2)}` : `$${Math.round(dollars)}`;
  };

  return (
    <aside className="template-filters">
      <div className="filters-header">
        <h2 className="filters-title">Filters</h2>
        <span className="filters-count">{totalCount} services</span>
      </div>

      {/* Search */}
      <div className="filter-section">
        <label className="filter-label">Search</label>
        <input
          type="text"
          className="filter-search"
          placeholder="Search templates..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      {/* Sort */}
      <div className="filter-section">
        <label className="filter-label">Sort By</label>
        <select
          className="filter-select"
          value={sortBy}
          onChange={(e) => onSortChange(e.target.value)}
        >
          {sortOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* Price Range */}
      <div className="filter-section">
        <label className="filter-label">
          Price Range: {formatPrice(priceRange[0])} - {formatPrice(priceRange[1])}
        </label>
        <div className="price-inputs">
          <input
            type="range"
            min="499"
            max="19900"
            step="100"
            value={priceRange[0]}
            onChange={(e) =>
              onPriceRangeChange([parseInt(e.target.value), priceRange[1]])
            }
            className="price-slider"
          />
          <input
            type="range"
            min="499"
            max="19900"
            step="100"
            value={priceRange[1]}
            onChange={(e) =>
              onPriceRangeChange([priceRange[0], parseInt(e.target.value)])
            }
            className="price-slider"
          />
        </div>
      </div>

      {/* Categories */}
      <div className="filter-section">
        <label className="filter-label">Categories</label>
        <div className="category-list">
          {categories.map((cat) => (
            <label key={cat.category} className="category-checkbox">
              <input
                type="checkbox"
                checked={selectedCategories.includes(cat.category)}
                onChange={() => handleCategoryToggle(cat.category)}
              />
              <span className="category-name">{cat.category}</span>
              <span className="category-count">{cat.count}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Clear Filters */}
      {(selectedCategories.length > 0 ||
        searchQuery ||
        priceRange[0] > 499 ||
        priceRange[1] < 19900) && (
        <button
          className="clear-filters"
          onClick={() => {
            onCategoryChange([]);
            onSearchChange('');
            onPriceRangeChange([499, 19900]);
          }}
        >
          Clear All Filters
        </button>
      )}
    </aside>
  );
}

export default TemplateFilters;
